<script setup lang="ts">
import type { USP } from '~/types/product.model'

defineProps<{
  usps: USP[]
}>()
</script>

<template>
  <div class="app-usp__container">
    <p
      v-for="(usp, index) in usps"
      :key="`usp-${index}`"
      class="app-usp"
      data-test="app-usp"
    >
      <IconGreenCheck class="app-usp__icon" />
      {{ usp.title }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
@use '@/assets/styles/helpers' as *;

.app-usp__container {
  display: grid;
  gap: var(--app-spacer-12);
}

.app-usp {
  display: flex;
  gap: var(--app-spacer-12);
  margin: 0;
  font-weight: 700;
}

.app-usp__icon {
  margin-top: set-rem-size(3px);
  width: set-rem-size(18px);
  min-width: set-rem-size(18px);
  height: set-rem-size(18px);
}
</style>
